import { FC, useState } from "react";
import { TicketRow } from "entities/support-ticket";
import { InfiniteList, Tabs } from "shared/ui";
import { STATUS_FILTERS } from "../model/statusFilters";
import type { StatusFilter } from "../model/statusFilters";
import { useTicketsList } from "../model/useTicketsList";

interface Props {
  onOpenTicket: (ticketId: number) => void;
}

export const TicketsList: FC<Props> = ({ onOpenTicket }) => {
  const [filter, setFilter] = useState<StatusFilter>("all");
  const list = useTicketsList(filter);

  return (
    <>
      <Tabs items={STATUS_FILTERS} active={filter} onChange={setFilter} />
      <InfiniteList
        {...list}
        emptyText="No requests yet"
        getKey={(ticket) => ticket.id}
        renderItem={(ticket) => (
          <TicketRow ticket={ticket} onClick={onOpenTicket} />
        )}
      />
    </>
  );
};
